import { Typography } from "@mui/material";
import { useState } from "react";
import type { MouseEvent } from "react";

interface CaptionProps {
  caption?: string;
}

export const Caption = ({ caption }: CaptionProps) => {
  const [showFullCaption, setShowFullCaption] = useState<boolean>(false);

  const shouldTruncateCaption = caption && caption.length > 100;
  const displayCaption =
    shouldTruncateCaption && !showFullCaption
      ? `${caption.substring(0, 99)}...`
      : caption;

  const handleCaptionClick = (e: MouseEvent<HTMLSpanElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setShowFullCaption(!showFullCaption);
  };

  return (
    <div>
      <Typography variant="body2" component="span">
        {caption ? displayCaption : "No Caption Found"}
      </Typography>
      {shouldTruncateCaption && (
        <Typography
          variant="body2"
          component="span"
          onClick={handleCaptionClick}
          sx={{
            color: "primary.main",
            cursor: "pointer",
            marginLeft: 1,
            textDecoration: "underline",
            "&:hover": {
              opacity: 0.8,
            },
          }}
        >
          {showFullCaption ? " Show less" : " Show more"}
        </Typography>
      )}
    </div>
  );
};
